import { createFileRoute } from '@tanstack/react-router';
import { BrainChat } from '~/components/brain/BrainChat';

export const Route = createFileRoute('/_app/brain/ask')({
  component: () => <BrainChat />,
});
